// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iYvmP","fullWidth":"Button_fullWidth__ORz-8","primary":"Button_primary__5c2Uy","secondary":"Button_secondary__6iFOr"};